import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ResponsivePagination from "react-responsive-pagination";
import "react-responsive-pagination/themes/classic.css";
import { deleteData, getListData, patchActiveData, useDebounce } from "../../hooks/api/utils";
import Loader from "../../components/loader/loader";
import Sidebar from "../sidebar/sidebar";
import CommonModal from "../../components/modal/modal";

const IndustryList = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const page_size = 10;
  const [search, setSearch] = useState("");
  const debouncedInput = useDebounce(search, 500, setPage);
  const [isActive, setIsActive] = useState("");
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedIndustryId, setSelectedIndustryId] = useState(null);
  const [selectedIndustryName, setSelectedIndustryName] = useState("");
  const pageCount = Math.ceil((data?.count || data?.length) / page_size);

  const getData = async () => {
    await getListData(
      "/admin-panel/industries/",
      setLoading,
      setData,
      page,
      page_size,
      `&is_active=${isActive}&search=${search}`
    );
  };

  useEffect(() => {
    getData();
  }, [debouncedInput, isActive]);

  const handlePageClick = (page) => {
    setPage(page);
    getData();
  };

  const handleToggleStatus = async (industry) => {
    await patchActiveData( 
      "/admin-panel/industries/",
      industry?.id,
      setLoading,
      {},
      () => {},
      ""
    );
    getData();
  };

  const confirmDelete = async () => {
    if (!selectedIndustryId) return;
    await deleteData("/admin-panel/industries/", selectedIndustryId);
    setSelectedIndustryId(null);
    setIsDeleteModalOpen(false);
    setPage(1);
    getData();
  };

  return (
 <>
      <div className="rightContent">
        <div className="viewMain">
          <div className="row">
            <div className="col-md-12 bg-white left-col p-2">
              <div className="d-flex justify-content-between align-items-center mt-4 p-4 gap-4">
                <h4>Industry</h4>
                <div className="width-25 d-flex justify-content-end">
                  <Link to={"/add-industry"} className="blue_btn width-75">
                    Add Industry
                  </Link>
                </div>
              </div>
              <div className="sortSearchArea search-margin mt-0 p-4">
                <div className="width-25">
                  <select
                    onChange={(e) => setIsActive(e.target.value)}
                    defaultValue={isActive}
                  >
                    <option value="" selected>
                      All
                    </option>
                    <option value="true">Active</option>
                    <option value="false">Inactive</option>
                  </select>
                </div>
                <div className="search">
                  <input
                    type="search"
                    placeholder="Search"
                    className="search-input"
                    onChange={(e) => setSearch(e.target.value)}
                  />
                  <span
                    style={{ background: "none", border: "none", padding: 0 }}
                  >
                    <img
                      src="../images/search-dark.svg"
                      className="img-fluid"
                      alt="Search"
                    />
                  </span>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  <div className="pateintData">
                    <div className="treatmentData tableTransactionData table-responsive">
                      <table className="table equal-spacing-table">
                        <thead className="tableTransactionHead">
                          <tr>
                            <th scope="col">Id</th>
                            <th scope="col">Name</th>
                            <th scope="col">Status</th>
                            <th scope="col">Actions</th>
                          </tr>
                        </thead>
                        <tbody className="tableData-color">
                          {
                            loading ? (
                              <Loader />
                            ) : (
                              data?.results?.map((d, idx) => (
                                <tr key={idx}>
                                  <td>{d.id}</td>
                                  <td>{d.name}</td>
                                  <td
                                    className={
                                      d.is_active
                                        ? "text-green"
                                        : "main-grey-text"
                                    }
                                  >
                                    {d.is_active ? "Active" : "Inactive"}
                                  </td>
                                  <td>
                                    <div className="d-flex flex-wrap gap-3 align-items-center justify-content-center justify-content-md-end action-buttons">
                                      <img
                                        src={
                                          d.is_active
                                            ? "images/blockicon.svg"
                                            : "images/unblockIcon.svg"
                                        }
                                        width="20"
                                        className="img-fluid"
                                        alt={d.is_active ? "block" : "unblock"}
                                        title={
                                          d.is_active ? "Inactive" : "Active"
                                        }
                                        style={{ cursor: "pointer" }}
                                        onClick={() => handleToggleStatus(d)}
                                      />
                                      <Link
                                        to={"/edit-industry"}
                                        state={{ id: d.id, industry: d }}
                                        className="border-0 bg-transparent"
                                      >
                                        <img
                                          src="images/pencilIcon.svg"
                                          width="25"
                                          className="img-fluid"
                                          title="Edit"
                                          alt="arrow"
                                        />
                                      </Link>
                                      {/* <button
                                      className="border-0 bg-transparent"
                                      onClick={() => deleteHandle(d.id)}
                                    >
                                      <img
                                        src="images/deleteGreyIcon.svg"
                                        width="20"
                                        className="img-fluid"
                                        alt="arrow"
                                      />
                                    </button> */}
                                      <button
                                        className="border-0 bg-transparent"
                                        onClick={() => {
                                          setSelectedIndustryId(d.id);
                                          setSelectedIndustryName(d.name);
                                          setIsDeleteModalOpen(true);
                                        }}
                                      >
                                        <img
                                          src="images/deleteGreyIcon.svg"
                                          width="20"
                                          className="img-fluid"
                                          title="Delete"
                                          alt="delete"
                                        />
                                      </button>
                                    </div>
                                  </td>
                                </tr>
                              ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <ResponsivePagination
                    className="pagination justify-content-center mt-5"
                    current={page}
                    total={pageCount || 0}
                    onPageChange={handlePageClick}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <CommonModal
        isOpen={isDeleteModalOpen}
        onRequestClose={() => {
          setSelectedIndustryId(null);
          setSelectedIndustryName("");
          setIsDeleteModalOpen(false);
        }}
        title="Confirm Delete"
      >
        <p className="text-center mb-4">
          Are you sure you want to delete <b>{selectedIndustryName}</b> industry?
        </p>
        <div className="d-flex justify-content-end gap-3">
          <button
            className="transparent_btn"
            onClick={() => {
              setIsDeleteModalOpen(false);
              setSelectedIndustryId(null);
              setSelectedIndustryName("");
            }}
          >
            Cancel
          </button>
          <button className="red_btn" onClick={confirmDelete}>
            Confirm
          </button>
        </div>
      </CommonModal>
      </>
  );
};

export default IndustryList;
